import type { CatalogParams } from "@shared/components/CatalogSearch/CatalogSearch";
import type { ParamsOptions } from "@shared/hooks/useUrlParams/useUrlParams";
import { useUrlParams } from "@shared/hooks/useUrlParams/useUrlParams";

const useCatalogParams = (
  initialOptions?: ParamsOptions
): [CatalogParams, (params: CatalogParams, options?: ParamsOptions) => void] => {
  return useUrlParams<CatalogParams>(initialOptions);
};

export { useCatalogParams };
